module.exports = __webpack_public_path__ + "img/balance_bg.785056e1.png";